module.exports = __webpack_public_path__ + "img/medlabo_top2.6c561020.jpg";